declare global {
    interface Window {
        _babelPolyfill: any
        performance: {
            now(): number
        }
    }
}

import promiseFinally from 'promise.prototype.finally'
import BluebirdPromise from 'bluebird'
import coreJs from 'babel-runtime/core-js'
import 'nodent-runtime'
import '@babel/polyfill'

BluebirdPromise.config({ cancellation: true })

promiseFinally.shim()

window.Promise = coreJs.Promise

// This line in particular protects against Safari versions > 8
// where window.performance is not available.
// We specifically stub the now function b/c THREE.js depends on it
window.performance = window.performance || {
    now: Date.now,
}
